import {
    FETCH_DATA_PROJECTS_STATUS_REQUEST,
    FETCH_DATA_PROJECTS_STATUS_SUCCESS,
    FETCH_DATA_PROJECTS_STATUS_FAILURE,
} from '../../actions/projects/get-project-status-action';

const initialState = {
    list: [],
    isLoading: false,
    error: null,
    meta: null
};

const ProjectsStatusReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DATA_PROJECTS_STATUS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DATA_PROJECTS_STATUS_SUCCESS:
            console.log("FETCH_DATA_PROJECTS_STATUS_SUCCESS", action.payload)
            return {
                ...state,
                isLoading: false,
                list: action.payload
            };
        case FETCH_DATA_PROJECTS_STATUS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default ProjectsStatusReducer;